import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "t6_table_c2" }
const _hoisted_2 = { class: "textLeft" }
const _hoisted_3 = ["href"]
const _hoisted_4 = ["href"]
const _hoisted_5 = { src: "/images/ysc.png" }
const _hoisted_6 = { class: "upload_td" }
const _hoisted_7 = { class: "upload_div" }
const _hoisted_8 = { class: "num" }
const _hoisted_9 = { style: {"min-height":"300px"} }
const _hoisted_10 = { class: "dialog-footer" }

import {
  getServiceMaterialList,
  getZzList,
  licenseDownload,
  preServiceMaterialCertificateList,
  upBase64File
} from "@/config/request";
import {ElLoading, ElMessage} from "element-plus";
import { nextTick, reactive, ref, toRefs } from "vue";
import { UploadFilled } from '@element-plus/icons-vue'
import Nav from "./nav.vue";
import { AREA_ID,FILE_URL } from "@/config/const";
import type { UploadProps, UploadUserFile } from 'element-plus'
import {useStore} from "vuex";
import {useRoute} from "vue-router";
import { IMG_PREVIEW } from '@/config/const';

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    publicData: Object
},
  setup(__props, { expose: __expose }) {

const mzbDialogVisible = ref(false)

const props = __props
let fileUrl = ref(FILE_URL)
console.log('fileUrl',fileUrl);
const route = useRoute()
const data = reactive({
  itemList:[],
  matterList:[] as any,
  materials: {} as any,
  query: route.query
})

let dialogVisible = ref(false)
let matterTitle = ref('')
let currentPreAttrFiles = ref([]) as any
let currentUnid = ref('')

const openFile=(value:string) => {
  if (value!==""){
   let fileId= value.split("fileId=")[1]
    return IMG_PREVIEW+fileId
  }
}
const init = () => {
  if(data.query.tagName == 'mzb'){
    mzbDialogVisible.value =true;
  }
}
init()

const mzbReject = () => {
  mzbDialogVisible.value =false;
}
const mzbAgree = async() => {
  const loading = ElLoading.service({
    lock: true,
    text: '证照共享中，请等候！',
    background: 'rgba(0, 0, 0, 0.7)',
  })
  mzbDialogVisible.value =false;
  let param = {
    serviceCode: publicData.value.basicInfo.preApasinfo.servicecode
  }
  const res = await preServiceMaterialCertificateList(param) as any
  if (res.result.records.length > 0) {
    let count =0;
    let materialCertificateList = res.result.records;
    for (let a = 0; a < materialCertificateList.length; a++) {
      let element = materialCertificateList[a];
      currentUnid.value = element.materialUnid
      let certificateName = element.certificateName;
      let zzparam = {
        //CertificateType: '中华人民共和国不动产权证书',
        CertificateType: certificateName,
        holderCode: publicData.value.basicInfo.preApasinfo.certificateSno
      }
      const zzres = await getZzList(zzparam) as any
      if(zzres.code == 200 && zzres.result !=null){
        count++;
        let zzInfo= zzres.result[0];
        await downLicenseFile(zzInfo.certificateID);
      }
    }
    if(count == 0){
      ElMessage.warning('未查询到你的证照信息，请正常上传材料申请办理！')
    }else {
      ElMessage.success('证照共享成功！')
    }
  }
  loading.close()
}

//材料附件回显
const shareFileLicense =(text:String) =>{
  let result={
    name:text.fileName+'.png',
    raw:{
      name:text.fileName+'.png',
      uid:uuid(),
      type:'image/jpeg'
    },
    response:text,
    uid:uuid(),
    status:'success'
  }
  let preAttrs = publicData.value.basicInfo.preAttrs
  for(let i = 0; i < preAttrs.length; i++){
    let preAttr = preAttrs[i]
    if(currentUnid.value === preAttr.attrid){
      publicData.value.basicInfo.preAttrs[i].preAttrFiles2.push(result)
    }}
}
//下载证照附件并上传到附件服务器
const downLicenseFile = async (licenseId:String) =>{
  let downparam = {
    fileNumber: licenseId
  }
  const res = await licenseDownload(downparam) as any
    let base64 =res.data.dataList[0]
    let base64param ={
      base64: base64
    }
  const base64res = await upBase64File(base64param) as any
      if (base64res.code = 200){
        shareFileLicense(base64res.result[0])
        console.log(base64res.result[0])
      }
}
const showDialog = (item:any) => {
    currentPreAttrFiles.value = []
    console.log('item',item);
    let name = `上传【${item.attrname}】的附件`
    matterTitle.value = name
    currentPreAttrFiles.value = item.preAttrFiles2
    currentUnid.value = item.unid
    setTimeout(()=>{
        dialogVisible.value = true
    },100)
}
const closeDialog = () => {
    console.log('关闭');
    currentPreAttrFiles.value = []
    currentUnid.value = ''
    matterTitle.value = ''
}
const { publicData } = toRefs(props) as any

const handleChange: UploadProps['onChange'] = (uploadFile, uploadFiles) => {

}
const handleSuccess:UploadProps['onSuccess'] = (response,file,files) => {
    console.log('onSuccess-response',response);
    let fileId = ''
    if(response.code === 0){
        ElMessage.success('上传成功')
        fileId = response.fileId
    }else{
        ElMessage.error('上传失败')
    }
    console.log('onSuccess-file',file);
    console.log('onSuccess-files',files);
    console.log('onSuccess---basicInfo.preAttrs',publicData.value.basicInfo.preAttrs);
    console.log('currentPreAttrFiles',currentPreAttrFiles.value);
    let preAttrs = publicData.value.basicInfo.preAttrs
    for(let i = 0; i < preAttrs.length; i++){
        let preAttr = preAttrs[i]

        if(currentUnid.value === preAttr.unid){
            preAttr.preAttrFiles2 = currentPreAttrFiles.value
        }
    }
    console.log('onSuccess2---basicInfo.preAttrs',publicData.value.basicInfo.preAttrs);

}

const getData = async() => {
    let param = {
        pageSize:301,
        pageNo: 1,
        code: publicData.value.basicInfo.preApasinfo.servicecode
    }
    const res = await getServiceMaterialList(param) as any

    if (res.result.size > 0) {
        let saveMaterials = [] as any;
        let queryMaterials = res.result.records;
        console.log(queryMaterials);
        for (let a = 0; a < queryMaterials.length; a++) {
            let m = {} as any;
            m['copyNum'] = queryMaterials[a].copyNum || ''
            m['importLevel'] = queryMaterials[a].importLevel || ''
            m['memo'] = queryMaterials[a].memo || ''
            m['srcNum'] = queryMaterials[a].srcNum || ''
            m['amount'] = ''
            m['areacode'] = AREA_ID
            m['attrid'] = queryMaterials[a].unid || ''
            m['attrname'] = queryMaterials[a].name || ''
            m['belongsystem'] = publicData.value.basicInfo.preApasinfo.belongsystem
            m['dataversion'] = '1'
            m['exBatch'] = ''
            m['extend'] = queryMaterials[a].sync || ''
            m['fileUrl'] = ''
            m['filename'] = ''
            m['isChecked'] = ''
            m['istake'] = ''
            m['lastUpdateTime'] = ''
            m['projid'] = publicData.value.basicInfo.preApasinfo.projid
            m['sortid'] = queryMaterials[a].sortid
            m['syncStatus'] = ''
            m['taketype'] = 'upload'
            m['unid'] = uuid()
            m['preAttrFiles'] = []  //  申报保存的参数-上传的材料(格式不一样)
            m['preAttrFiles2'] = [] //  存储上传组件上传的材料(格式不一样)
            m['importLevel_dictText'] = queryMaterials[a].importLevel_dictText
            saveMaterials.push(m);
        }
        publicData.value.basicInfo.preAttrs = saveMaterials ;

    }else {
        //this.$refs.modelForm3.nextStep();
        console.log('无材料 直接下一步');

    }

}

const uuid = () => {
    let s = [] as any
    let hexDigits = '0123456789abcdef'
    for (let i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
    }
    s[14] = '4'
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1)
    s[8] = s[13] = s[18] = s[23] = '-'

    let uuid = s.join('')
    return uuid
}

const check = () => {
    let status = 200    //  返回状态
    let preAttrs = publicData.value.basicInfo.preAttrs
    const attrsLength = preAttrs.length
    for(let i = 0; i < attrsLength; i++){

    }
    preAttrs.forEach((res:any) => {
        if('2' === res.importLevel && res.preAttrFiles2.length == 0){
          console.log('有必须上传的材料没有上传');
          status = 500
        }
    });

    if(status === 200){
        preAttrs.forEach((res:any) => {
            const preAttrFiles2 = res.preAttrFiles2
            const length2 = preAttrFiles2.length
            if(length2 > 0){
                for(let j = 0; j < length2; j++){
                    let file = {} as any
                    file['attrUnid'] = res.unid
                    file['fileName'] = preAttrFiles2[j].name
                    file['fileUnid'] = JSON.parse(preAttrFiles2[j].response.result).fileId
                    file['fileUrl'] = ''
                    file['unid'] = uuid()
                    res.preAttrFiles.push(file)
                }
            }
        });
    }else{
        ElMessage.error('有必传的材料未上传')
    }

    let result = {
        data: publicData.value,
        status: status
    }
    return result
}

__expose({
    check
})


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Nav),
    _cache[9] || (_cache[9] = _createElementVNode("div", { class: "t6_title_h2" }, "申请材料", -1)),
    _createElementVNode("table", _hoisted_1, [
      _cache[4] || (_cache[4] = _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("th", { width: "100" }, "序号"),
          _createElementVNode("th", null, "申请材料"),
          _createElementVNode("th", { width: "150" }, "样表下载"),
          _createElementVNode("th", { width: "150" }, "是否必要"),
          _createElementVNode("th", { width: "150" }, "是否上传"),
          _createElementVNode("th", { width: "150" }, "操作")
        ])
      ], -1)),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(publicData).basicInfo.preAttrs, (item, i) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: item.id
          }, [
            _createElementVNode("td", null, _toDisplayString(i+1), 1),
            _createElementVNode("td", _hoisted_2, _toDisplayString(item.attrname), 1),
            _createElementVNode("td", null, [
              (item.fileUrl)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: openFile(item.fileUrl),
                    onClick: _cache[0] || (_cache[0] = () => {})
                  }, "空表", 8, _hoisted_3))
                : _createCommentVNode("", true),
              (item.examplefileUrl)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 1,
                    style: {"margin-left":"4px","text-decoration":"none"},
                    href: openFile(item.examplefileUrl)
                  }, "样表", 8, _hoisted_4))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("td", null, _toDisplayString(item.importLevel_dictText), 1),
            _createElementVNode("td", null, [
              _withDirectives(_createElementVNode("img", _hoisted_5, null, 512), [
                [_vShow, item.preAttrFiles2.length > 0]
              ])
            ]),
            _createElementVNode("td", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("span", null, [
                  _createVNode(_unref(UploadFilled), {
                    class: "upload_icon",
                    onClick: ($event: any) => (showDialog(item))
                  }, null, 8, ["onClick"])
                ]),
                _createElementVNode("span", _hoisted_8, _toDisplayString(item.preAttrFiles2.length), 1)
              ])
            ])
          ]))
        }), 128))
      ])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: _unref(dialogVisible),
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(dialogVisible) ? (dialogVisible).value = $event : dialogVisible = $event)),
      title: _unref(matterTitle),
      width: "800px",
      onClose: closeDialog
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_el_upload, {
            class: "upload-demo",
            "file-list": _unref(currentPreAttrFiles),
            "onUpdate:fileList": _cache[1] || (_cache[1] = ($event: any) => (_isRef(currentPreAttrFiles) ? (currentPreAttrFiles).value = $event : currentPreAttrFiles = $event)),
            action: _unref(fileUrl),
            multiple: "",
            "on-change": handleChange,
            "on-success": handleSuccess
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createVNode(_component_el_button, { type: "primary" }, {
                  default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                    _createTextVNode("上传", -1)
                  ]))]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }, 8, ["file-list", "action"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_dialog, {
      modelValue: mzbDialogVisible.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((mzbDialogVisible).value = $event)),
      title: "免证办理须知",
      width: "30%",
      "align-center": true,
      center: true,
      "close-on-click-modal": false,
      "show-close": false,
      "lock-scroll": false
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_10, [
          _createVNode(_component_el_button, {
            type: "danger",
            onClick: mzbReject
          }, {
            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
              _createTextVNode("拒绝", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: mzbAgree
          }, {
            default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
              _createTextVNode(" 同意 ", -1)
            ]))]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _cache[8] || (_cache[8] = _createElementVNode("span", null, " 尊敬的申请人你好，免证办理需要获取你办理该事项所需的证照信息，是否同意？ ", -1))
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})